import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { trigger, transition, useAnimation } from '@angular/animations';
import { fadeInDown } from 'ng-animate';
import { ApirequestService } from '../../../../services/apirequest/apirequest.service';
import { ApiurlsService } from '../../../../services/api-urls/apiurls.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import { UtilityService } from '../../../../services/utilities/utilities.services';
import { EmailTemplate } from '../../../../model/email.model';


@Component({
  selector: 'hybse-admin-create-templates',
  templateUrl: './create-templates.component.html',
  styleUrls: ['./create-templates.component.css'],
  animations: [
    trigger('fadeInDown', [transition('* => *', useAnimation(fadeInDown, {
      params: {
        timing: 1,
        a: '-10px'
      }
    }))])
  ]
})
export class CreateTemplatesComponent implements OnInit {

  createTemplateForm: FormGroup;
  fadeInDown: any;
  allLocaleList: any = [];
  formResponseMsg: string = '';
  alertStatusMessage: boolean = false;
  showLoader: boolean = false;

  public type: string;
  public messageTypes: string[] = ['Internal', 'External'];
  public allLocale: string[] = ['English', 'German']
  public emailTemplate: EmailTemplate = new EmailTemplate();
  public emailId: string;
  public selectedLanguage: string;
  public actions: string[] = ['null','InvReg', 'IssReg', 'InvConf', 'IssConf', 'PwdReset', 'EmailChange']
  public options: Object = {
    placeholderText: 'Edit Mail Content Here!',
    charCounterCount: false,
    height: 450
  }
  // @Input() actionType: string = 'add';

  constructor(private _fb: FormBuilder,
    private _req: ApirequestService,
    private _urls: ApiurlsService,
    private router: Router,
    private _utils: UtilityService,
    private route: ActivatedRoute,
    private _dom: DomSanitizer,
  ) {
    this.route.data.subscribe((value) => {
      let type = value['type'];
      this.type = (type === 'edit') ? type : type;
    });
  }

  ngOnInit() {
    this.createTemplateFormInit();
    this.getLocaleList();
    this.route.params.subscribe(
      params => {
        this.emailId = params.id;
        if (this.emailId) {
          this.getTemplateData();
        }
      });
  }

  // getActionType() {
  //   if (this.actionType == 'edit') this.showLoader = true;
  // }

  createTemplateFormInit() {
    this.createTemplateForm = this._fb.group({
      'title': ['', [Validators.required]],
      'locale': ['', [Validators.required]],
      'messageType': ['', [Validators.required]],
      'mailContent': ['', [Validators.required]],
      'templateId': [null, Validators.required],
      'action': [null]
    });
  }

  createUpdateTemplate() {

    for (const index in this.createTemplateForm.controls) {
      this.createTemplateForm.controls[index].markAsTouched();
    }
    if (this.createTemplateForm.invalid) {
      return;
    }

    console.log(this.emailTemplate);

    if (this.createTemplateForm.valid) {
      this.showLoader = true;
      // let formVal = this.createTemplateForm.value;
      // let data: any = {
      //   idLocale: formVal.locale,
      //   parent: 1,
      //   childId: 1,
      //   templateId: 1,
      //   messageType: formVal.messageType, //Internal or External
      //   title: formVal.title,
      //   body: formVal.mailContent
      // };

      let url = (this.type == 'edit') ? this._urls.updateMessageTemplateUrl : this._urls.createMessageTemplateUrl;
      if (this.type == 'edit') this.emailTemplate.idMessageTemplate = this.emailId;

      //  ( this.langContent.german != '' ) ? this.multipleReq(url,data) : this.sendPageData(url,data);
      this._req.fetchApiData(url, this.emailTemplate, 'post').subscribe(
        (data: any) => {
          console.log('template', data);
          let resSucc = data.data;
          let resErr = data.error;
          this._utils.scrollToY(0, 400, 'easeInOutQuint');
          this.showLoader = false;
          if (resSucc != '') {
            this.alertStatusMessage = true;
            this.formResponseMsg = resSucc['Success Description'];
            setTimeout(() => {
              this.cancelTemplateCreate();
            }, 2000);
          }
          if (resErr != '') {
            this.formResponseMsg = resErr['Error Description']
          }
        },
        error => {

        })
    }
  }

  cancelTemplateCreate() {
    for (const index in this.createTemplateForm.controls) {
      this.createTemplateForm.controls[index].markAsUntouched();
    }
    this.router.navigate(['/mail-template/list']);
  }


  getLocaleList() { // Make it common
    this._req.fetchApiData(this._urls.listLocaleUrl, {}).subscribe(
      (data: any) => {
        let response = data.data;
        if (response.length != 0) {
          this.allLocaleList = response;
          console.log(this.allLocaleList);
        }
      },
      error => {

      },
      () => {

      }
    );
  }


  getTemplateData() {
    let data = {
      idMessageTemplate: this.emailId
    }
    this._req.fetchApiData(this._urls.getTemplateByIdUrl, data, 'post').subscribe(
      (data: any) => {
        if (data && data.data) {
          this.emailTemplate = data.data;

        }
      }, (error) => {

        // if (this.emailTemplate) this.setTemplateData(this.emailTemplate);
      });
  }

  // setTemplateData(data) {
  //   let value = data[0];
  //   this.showLoader = false;
  //   this.createTemplateForm.patchValue({
  //     'title': value.title,
  //     'locale': value.idLocale.toString(),
  //     'messageType': value.messageType,
  //     'mailContent': value.body,
  //     'templateId': value.templateId,
  //     'action': value.action
  //   });
  // }

  ngOnChanges() {
    //this.getActionType();
  }

}



// WEBPACK FOOTER //
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/app/components/pages/mail-templates/create-templates/create-templates.component.ts